export const CONTACTS_PATH = 'api/landlord/contacts';
